import Vue from "vue";
import Inputmask from "inputmask";

Vue.directive("mask-percent", {
  bind: function(el) {
    new Inputmask({
      nullable: false,
      clearMaskOnLostFocus: false,
      clearIncomplete: true,
      alias: "percentage",
      suffix: "",
      digits: 1,
      enforceDigitsOnBlur: false,
      autoUnmask: true,
      removeMaskOnSubmit: true,
      digitsOptional: true, // vuejs thì để true với digits nếu không thì nhập bằng mắt
      positionCaretOnClick: "none",
      allowMinus: false
    }).mask(el);
    el.addEventListener("focus", e => {
      e.currentTarget.select();
    });
  }
});

Vue.directive("mask-currency-int", {
  bind: function(el) {
    new Inputmask({
      nullable: false,
      clearMaskOnLostFocus: true,
      clearIncomplete: true,
      alias: "integer",
      groupSeparator: ",",
      enforceDigitsOnBlur: true,
      radixPoint: ".",
      autoUnmask: true,
      removeMaskOnSubmit: true,
      digitsOptional: false,
      positionCaretOnClick: "none",
      selectOnFocus: true,
      allowMinus: false
    }).mask(el);
    el.addEventListener("focus", e => {
      e.currentTarget.select();
    });
  }
});
Vue.directive("mask-currency-de", {
  bind: function(el) {
    new Inputmask({
      nullable: false,
      clearMaskOnLostFocus: true,
      clearIncomplete: true,
      alias: "decimal",
      groupSeparator: ",",
      radixPoint: ".",
      digits: 2,
      enforceDigitsOnBlur: true,
      autoUnmask: true,
      removeMaskOnSubmit: true,
      positionCaretOnClick: "none",
      digitsOptional: false,
      allowMinus: false
    }).mask(el);
    el.addEventListener("focus", e => {
      e.currentTarget.select();
    });
  }
});

Vue.directive("mask-single-date", {
  bind: function(el) {
    new Inputmask({
      nullable: false,
      clearMaskOnLostFocus: true,
      clearIncomplete: true,
      alias: "datetime",
      inputFormat: "dd/mm/yyyy",
      positionCaretOnClick: "none",
      jitMasking: true,
      showMaskOnFocus: false,
      showMaskOnHover: false
    }).mask(el);
  }
});

Vue.directive("mask-double-date", {
  bind: function(el) {
    new Inputmask({
      nullable: false,
      clearMaskOnLostFocus: true,
      clearIncomplete: true,
      alias: "datetime",
      inputFormat: "dd/mm/yyyy-dd/mm/yyyy",
      positionCaretOnClick: "none",
      jitMasking: true,
      showMaskOnFocus: false,
      showMaskOnHover: false
    }).mask(el);
  }
});

Vue.directive("mask-time", {
  bind: function(el) {
    new Inputmask({
      nullable: false,
      clearMaskOnLostFocus: true,
      clearIncomplete: true,
      alias: "datetime",
      inputFormat: "HH:MM",
      positionCaretOnClick: "none",
      jitMasking: true,
      showMaskOnFocus: false,
      showMaskOnHover: false
    }).mask(el);
  }
});

Vue.directive("mask-int", {
  bind: function(el) {
    new Inputmask({
      nullable: false,
      clearMaskOnLostFocus: true,
      clearIncomplete: true,
      alias: "integer",
      min: 0,
      groupSeparator: ".",
      autoUnmask: true,
      placeholder: "",
      removeMaskOnSubmit: true
    }).mask(el);
  }
});
